/* ==========================================================================
   EZION — BANNER RAIL
   The rail is a scroll-snap row, so the browser owns the swipe, the momentum
   and the snap. This only nudges the scroll position on a timer and keeps the
   dots in step — which also means the markup still works as a scrollable row
   if this file never loads.
   ========================================================================== */
(function () {
  'use strict';

  class EzBanners extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-banner-track]');
      this.slides = Array.from(this.querySelectorAll('[data-banner-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-banner-dot]'));
      if (!this.track || this.slides.length < 2) return;

      this.index = 0;
      this.interval = parseInt(this.dataset.interval, 10) || 5000;

      this.dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          this.go(i);
          this.rest();
        }.bind(this));
      }, this);

      // The scroll position is the source of truth, not a counter we keep —
      // a swipe moves it without us and the dots have to follow.
      var sync = this.sync.bind(this);
      this.track.addEventListener('scroll', function () {
        clearTimeout(this.settle);
        this.settle = setTimeout(sync, 90);
      }.bind(this), { passive: true });

      // Leave it alone while it is being touched or read.
      ['pointerenter', 'focusin'].forEach(function (evt) {
        this.addEventListener(evt, this.stop.bind(this));
      }, this);
      ['pointerleave', 'focusout'].forEach(function (evt) {
        this.addEventListener(evt, this.start.bind(this));
      }, this);

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) { this.stop(); } else { this.start(); }
      }.bind(this));

      this.start();
    }

    disconnectedCallback() { this.stop(); }

    /** Which slide the rail has actually come to rest on. */
    sync() {
      var width = this.track.clientWidth || 1;
      var at = Math.round(this.track.scrollLeft / width);
      if (at === this.index) return;
      this.index = at;
      this.paint();
    }

    paint() {
      this.dots.forEach(function (dot, i) {
        dot.setAttribute('aria-selected', String(i === this.index));
      }, this);
    }

    go(index) {
      var count = this.slides.length;
      this.index = ((index % count) + count) % count;
      this.track.scrollTo({
        left: this.track.clientWidth * this.index,
        behavior: this.reduced() ? 'auto' : 'smooth'
      });
      this.paint();
    }

    reduced() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    start() {
      // Someone who has asked for less motion should not be handed a carousel
      // that moves on its own.
      if (this.timer || this.reduced()) return;
      this.timer = setInterval(function () { this.go(this.index + 1); }.bind(this), this.interval);
    }

    stop() {
      clearInterval(this.timer);
      this.timer = null;
    }

    /** Restart the clock so a deliberate tap is not overridden a moment later. */
    rest() {
      this.stop();
      this.start();
    }
  }

  if (!customElements.get('ez-banners')) customElements.define('ez-banners', EzBanners);
})();
